/**
 * @file avatar.tsx
 * @description Аватар-примитив с fallback инициалом (phase08.5).
 * Простой без AvatarImage — на этапе 1 показываем только initials.
 */

import * as React from "react";

import { cn } from "@/lib/utils";

export interface AvatarProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Имя или email для генерации инициала. */
  name?: string | null;
  /** Размер в пикселях (default 32). */
  size?: number;
}

export function Avatar({
  name,
  size = 32,
  className,
  style,
  ...props
}: AvatarProps) {
  const initial = React.useMemo(() => {
    if (!name) return "?";
    const trimmed = name.trim();
    return trimmed.length > 0 ? trimmed.charAt(0).toUpperCase() : "?";
  }, [name]);

  return (
    <div
      data-slot="avatar"
      className={cn(
        "inline-flex items-center justify-center rounded-full font-semibold select-none shrink-0",
        "bg-primary text-on-primary",
        className,
      )}
      style={{
        width: size,
        height: size,
        fontSize: Math.round(size * 0.42),
        ...style,
      }}
      {...props}
    >
      {initial}
    </div>
  );
}
